import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../redux/index';
import { useNavigate } from 'react-router-dom';
import PageContext from './PageContext';
import eyeIcon from '../../svgs/eye-details-icon.svg';
import PageTooltip from './PageTooltip'; 
import { TableCell } from '@mui/material';

const ConsortiumSearchRow = ({ row, count, tableHeader,selectableRows }) => {
    // get context variables from parent
    const {
        setViewModal, 
        setViewCompany,
    } = useContext(PageContext);
    // redux state for use of persistant state in different route (CompanyDetailsPage)
    const dispatch = useDispatch();
    const { setConsortiumId, setBackPath } = bindActionCreators(actionCreators, dispatch);
    const navigate = useNavigate();

    // event handler when link is clicked
    const onConsortiumClick = (e) =>{
        console.log(e.target); 
        // set back path to let navbar on next page to return to /CompanyProfilePage
        setBackPath('/ConsortiumSearchPage'); 
        // set consortium ID 
        setConsortiumId(e.target.innerText.toString()); 
    }

    const onRowClick = (input) =>{
        //event handler when anywhere in the row is clicked
        if(selectableRows){
            // set back path to let navbar on next page to return to /CompanyProfilePage
            setBackPath('/ConsortiumSearchPage'); 
            // set consortium ID 
            setConsortiumId(input); 
            navigate("/ConsortiumManagementPage");
        }
    }

    // event handler for view icon click to show modal that lists sub companies
    const onViewClick = (e) => {
        setViewModal(viewModal => viewModal = true); 
        setViewCompany(viewCompany => viewCompany = row); 
    }

    return(
        <>
            {tableHeader.map(el => {
                // logic to determine how to display each column based on name
                if ( el['columnname'] == 'consortiumid'){
                    return(
                        <TableCell onClick={()=>onRowClick(row['consortiumid'])} className= {selectableRows ? 'table-cell-clicky' :''}>
                            <div className='table-cell-link-row'>
                                {row[el['columnname']]}
                            </div>
                        </TableCell>
                    );
                }
                else if (el['columnname'] == 'mastercompanies'){
                    return (
                        <TableCell onClick={()=>onRowClick(row['consortiumid'])} className= {selectableRows ? 'table-cell-clicky' :''}>
                            <PageTooltip title='view'>
                                <img src={eyeIcon} className='data-table-icon-left' onClick={(e)=>{
                                    e.stopPropagation(); // Prevents the TableCell's onClick from firing
                                    onViewClick(e);}}/>
                            </PageTooltip>
                        </TableCell>
                    );
                }
                else if (row[el['columnname']] == null){
                    return(
                        <TableCell onClick={()=>onRowClick(row['consortiumid'])} className= {selectableRows ? 'table-cell-clicky' :''}>None</TableCell>
                    );
                }
                else{
                    return(
                        <TableCell onClick={()=>onRowClick(row['consortiumid'])} className= {selectableRows ? 'table-cell-clicky' :''}>{row[el['columnname']]}</TableCell>
                    );
                }
            })}
        </>
    ); 
}

export default ConsortiumSearchRow; 